var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo-img",attrs:{"src":_vm.appLogoImage,"alt":_vm.logoAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }